@if (currentTask(); as task) {
<mat-toolbar [syncWidthTo]="viewport">
  <button routerLink="./.." queryParamsHandling="merge" mat-icon-button>
    <mat-icon svgIcon="arrow_back"></mat-icon>
  </button>
  <h2>
    <mat-icon [svgIcon]="task | taskStateIcon" class="fix-icon-color" data-e2e="screen-task__state-icon"></mat-icon
    ><span data-e2e="screen-task__name">{{ task.name }}</span>
  </h2>
  <button-task-actions [task]="task"></button-task-actions>
</mat-toolbar>
<cdk-virtual-scroll-viewport [itemSize]="52" #viewport minBufferPx="200" maxBufferPx="2000">
  <table
    mat-table
    [dataSource]="sortSessions(task.sessions)"
    [trackBy]="trackSession"
    cdkDropList
    [cdkDropListSortingDisabled]="true"
  >
    <ng-container matColumnDef="start">
      <th mat-header-cell *matHeaderCellDef class="header-start">Start</th>
      <td mat-cell *matCellDef="let item" class="header-start" data-e2e="screen-task__session-start">
        {{ item.start | date: 'yyyy-MM-dd H:mm' }}
      </td>
      <td mat-footer-cell *matFooterCellDef class="header-start">Total</td>
    </ng-container>

    <ng-container matColumnDef="end">
      <th mat-header-cell *matHeaderCellDef class="header-end">End</th>
      <td mat-cell *matCellDef="let item" class="header-end" data-e2e="screen-task__session-end">
        {{ item.end | date: 'yyyy-MM-dd H:mm' }}
      </td>
      <td mat-footer-cell *matFooterCellDef class="header-end"></td>
    </ng-container>

    <ng-container matColumnDef="duration">
      <th mat-header-cell *matHeaderCellDef class="header-duration">Duration</th>
      <td mat-cell *matCellDef="let item" class="header-duration" data-e2e="screen-task__session-duration">
        <duration [value]="item | map: sessionDuration"></duration>
      </td>
      <td mat-footer-cell *matFooterCellDef class="header-duration" data-e2e="screen-task__task-duration">
        <duration [value]="task | map: taskDuration"></duration>
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef class="header-action"></th>
      <td mat-cell *matCellDef="let item" class="header-action">
        <button-session-actions
          [session]="item"
          [task]="task"
          data-e2e="screen-task__button-session-action"
        ></button-session-actions>
      </td>
      <td mat-footer-cell *matFooterCellDef class="header-action"></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let item; columns: displayedColumns"
      data-e2e="screen-task__session-row"
      cdkDrag
      [cdkDragData]="[item, task.id]"
    ></tr>
    <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
  </table>
</cdk-virtual-scroll-viewport>
@if (taskIsInProgress() === false) {
<button (click)="start(task.id)" mat-fab color="accent" matTooltip="Start" data-e2e="screen-task__button-start">
  <mat-icon svgIcon="play_arrow"></mat-icon>
</button>
} @if (taskIsInProgress() === true) {
<button (click)="stop(task.id)" mat-fab color="primary" matTooltip="Stop" data-e2e="screen-task__button-stop">
  <mat-icon svgIcon="pause"></mat-icon>
</button>
} }
